export default __webpack_public_path__ + "static/media/bluefilter_alt-24px.9ff9044d.svg";